import { jsx as _jsx } from "react/jsx-runtime";
import { createPolymorphicComponent, Alert as MantineAlert } from '@mantine/core';
import { XenIcon } from '../icons';
const _Alert = ({ icon, ...props }) => {
    const Icon = icon ? XenIcon[icon] : undefined;
    return _jsx(MantineAlert, { ...(Icon && { icon: _jsx(Icon, { fontSize: "inherit" }) }), ...props });
};
export const Alert = createPolymorphicComponent(_Alert);
